import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=2b8f3e1a&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=2b8f3e1a&prod&lang=css"
import style1 from "./ImageCropper.vue?vue&type=style&index=1&id=2b8f3e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f3e1a",
  null
  
)

export default component.exports